module.exports = __webpack_public_path__ + "media/images/OPL 8-8aedd91fccff222c9c0d23b1c7fa094f.png";